import React from 'react';
import NewVSStep2 from './NewVSStep2';

const NewVSStep2Container = (props) => {
  const { serverSizes, formikProp } = props;
  return <NewVSStep2 serverSizes={serverSizes} formikProp={formikProp} />;
};

export default NewVSStep2Container;
